import { connect } from 'react-redux'
import React from 'react'
import nodeTypesToClasses from './nodeTypesToClasses'

const nodeTypesToSymbols = {
    checkbox: <i className="far fa-circle"></i>,
    text: <i className="far fa-align-left"></i>,
    done: <i className="fas fa-check-circle"></i>,
    failed: <i className="far fa-alien-monster"></i>,
    waiting: <i className="far fa-hourglass-half"></i>,
    idea: <i className="far fa-lightbulb"></i>,
    cancelled: <i className="fas fa-moon"></i>
}

const ChildrenIconsComponent = ({ childrenTypes, type }) => {
    if (type === 'cancelled' || type === 'waiting') {
        return ''
    } else {
        return (
            <div className="children-icons">
                {childrenTypes.map((childType, i) => {
                    return (
                        <span key={i} className={'child-' + nodeTypesToClasses[childType]}>
                            {nodeTypesToSymbols[childType]}
                        </span>
                    )
                })}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    // Using manual selecting because selectors we have are heavier
    const { type, childrenIds } = state.nodes[ownProps.nodeId]
    const childrenTypes = childrenIds.map((id) => state.nodes[id].type)

    return {
        childrenTypes,
        type
    }
}

export const ChildrenIcons = connect(mapStateToProps)(ChildrenIconsComponent)
